<template>
  <div>
    <a-tabs>
      <a-tab-pane key="1" tab="重修规则设置">
        <RetakeRuleSetting />
      </a-tab-pane>
      <a-tab-pane key="2" tab="重修申请">
        <RetakeApplication />
      </a-tab-pane>
      <a-tab-pane key="3" tab="重修选课">
        <RetakeCourseSelection />
      </a-tab-pane>
      <a-tab-pane key="4" tab="重修名单">
        <RetakeStudentList />
      </a-tab-pane>
      <a-tab-pane key="5" tab="审批查询">
        <ApprovalQuery />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import RetakeRuleSetting from '../retake/RetakeRuleSetting.vue'
import RetakeApplication from '../retake/RetakeApplication.vue'
import RetakeCourseSelection from '../retake/RetakeCourseSelection.vue'
import RetakeStudentList from '../retake/RetakeStudentList.vue'
import ApprovalQuery from '../retake/ApprovalQuery.vue'

export default {
  components: {
    RetakeRuleSetting,
    RetakeApplication,
    RetakeCourseSelection,
    RetakeStudentList,
    ApprovalQuery
  }
}
</script>